(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-upsell-bundle"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initUpsellSwipeHint(root) {
    var section = root || document.getElementById('upsell-{{ section.id }}');
    if (!section || section.dataset.upsellSwipeInit === '1') return;
    section.dataset.upsellSwipeInit = '1';

    var slider = section.querySelector('[data-upsell-slider]');
    var hint = section.querySelector('[data-upsell-swipe-hint]');
    if (!slider || !hint) return;

    // Force mobile start at first card; also helps if theme tries centering middle
    function startAtFirst(){
      slider.scrollTo({ left: 0, behavior: 'auto' });
    }
    startAtFirst();
    setTimeout(startAtFirst, 300);
    setTimeout(startAtFirst, 900);

    // Fade hint after user interacts
    var faded = false;
    function fade() {
      if (faded) return;
      faded = true;
      hint.classList.add('fade');
    }
    slider.addEventListener('scroll', fade, { passive: true });
    hint.addEventListener('click', fade);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initUpsellSwipeHint(); });
  } else {
    initUpsellSwipeHint();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e && e.target && e.target.id === 'upsell-{{ section.id }}') {
      e.target.dataset.upsellSwipeInit = '0';
      initUpsellSwipeHint(e.target);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
